





















































import Vue from "vue";
import ModalDlg from "@/components/ModalDlg.vue";
import {Demo, DemoGroup, getBuiltinDemos, getThirdPartyLibraryDemos} from "@/helpers/demos";
import Parser from "@/parser/parser";
import {AppSPYPrefix} from "@/main";
import {escapeRegExp} from "lodash";

export default Vue.extend({
    components: {ModalDlg},
    
    props: {
        dlgId: String,
    },
    
    data: function() {
        return {
            availableDemos: [] as DemoGroup[],
            selectedDemoCategoryIndex: 0, // LHS, always a selection
            selectedDemoItemIndex: 0, // RHS, -1 if no selection
            demosInCurrentCategory: [] as { name: string, description: string | undefined, imgURL: string | undefined, demoFile: () => Promise<string | undefined> }[],
        };
    },
    
    methods: {
        updateAvailableDemos() {
            // We must update the available demos based on the code.
            // Our built-in demos are always available:
            this.availableDemos = [
                {name: this.$i18n.t("demos.builtinGraphics") as string, demos: getBuiltinDemos("graphics")},
                {name: this.$i18n.t("demos.builtinTurtle") as string, demos: getBuiltinDemos("turtle")},
                {name: this.$i18n.t("demos.builtinConsole") as string, demos: getBuiltinDemos("console")},
            ];
            // To get library demos, we first get the libraries:
            const p = new Parser();
            // We only need to parse the imports container:
            p.parseJustImports();
            // Then we can get the libraries and look for demos:
            for (const library of [...new Set(["github:k-pet-group/mediacomp-strype", ...p.getLibraries()])]) {
                this.availableDemos.push(getThirdPartyLibraryDemos(library));
            }
        },

        async changeDemoDialogCategory(index: number, itemPromise: Promise<Demo[]>) {
            this.selectedDemoCategoryIndex = index;
            this.demosInCurrentCategory = [];
            const demos = await itemPromise;
            const r = [];
            // Note async: will run each in background
            for (const demo of demos) {
                let img : Promise<string | undefined>;
                if ("dataURL" in demo.image) {
                    img = demo.image.dataURL;
                }
                else if ("imgURL" in demo.image) {
                    img = Promise.resolve(demo.image.imgURL);
                }
                else {
                    img = Promise.resolve<string | undefined>(undefined);
                }
                const details = {
                    name: demo.name,
                    description: demo.description,
                    imgURL: undefined as (string | undefined),
                    demoFile: demo.demoFile,
                };
                r.push(details);
                img.then((url) => {
                    Vue.set(details, "imgURL", url);
                });
            }
            this.demosInCurrentCategory = r;

        },
        
        // Called by Menu component when we are shown:
        shown() {
            this.changeDemoDialogCategory(0, this.availableDemos.length > 0 ? this.availableDemos[0].demos: Promise.resolve([]));
        },

        getSelectedDemo() : ({ name : string, demoFile: Promise<string | undefined> } | undefined) {
            if (this.selectedDemoItemIndex >= 0 && this.selectedDemoItemIndex < this.demosInCurrentCategory.length) {
                const d = this.demosInCurrentCategory[this.selectedDemoItemIndex];
                return {name: d.name, demoFile: d.demoFile()};
            }
            return undefined;
        },

        addSpecifiedLibrary() {
            let address = (this.$refs.newLibraryAddress as HTMLInputElement).value;
            address = address.trim();
            if (address) {
                // We want to be quite permissive here.  We accept the following syntaxes:
                // #(=> Library:protocol:addr
                // protocol:addr
                // addr <-- Guess protocol
                const mLib = address.match(new RegExp("^#\\s*" + escapeRegExp(AppSPYPrefix) + "\\s*Library:(.*)$"));
                if (mLib) {
                    address = mLib[1];
                    // We do the rest of the code anyway, in case some bits are incomplete:
                }
                if (!(address.startsWith("http:") || address.startsWith("https:") || address.startsWith("github:"))) {
                    // Need to guess the protocol.  Github usernames can't have dots, so a simple rule is this:
                    // If the first part before the first slash has a dot, it's a web URL.
                    // Special case: if it's "localhost" we also assume web URL.
                    // If it has two or three slashes we guess Github
                    // But otherwise we fall back to web URL again
                    // So let's assume web and just see if matches Github:
                    let protocol = "https://";
                    
                    // Does it have content before the first slash?
                    const mSlash = address.match(/^([^/]+)\//);
                    if (mSlash) {
                        if (!mSlash[1].includes(".") && !mSlash[1].toLowerCase().startsWith("localhost")) {
                            const components = address.split("/").length;
                            if (components == 2 || components == 3) {
                                protocol = "github:";
                            }
                        }
                    }
                    address = protocol + address;
                }
                this.availableDemos.push(getThirdPartyLibraryDemos(address));
            }
        },
    },
});
